module.exports = __webpack_public_path__ + "img/flag--en.fcfef678.svg";